/**
 * Componente LocalizedNavigate
 * Equivalente a `Navigate` de react-router que antepone el prefijo del idioma
 * actual al destino (por ejemplo, redirigir de una receta inexistente al
 * listado sin salirse del idioma que el usuario está usando).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useLocalizedPath from '../../hooks/useLocalizedPath';

/**
 * @param {Object} props - Propiedades (el resto se pasa a `Navigate`)
 * @param {string} props.to - Destino interno (ruta en español)
 * @returns {JSX.Element} Redirección localizada
 */
const LocalizedNavigate = ({ to, ...rest }) => {
  const localize = useLocalizedPath();
  return <Navigate to={localize(to)} {...rest} />;
};

LocalizedNavigate.propTypes = {
  to: PropTypes.string.isRequired,
};

export default LocalizedNavigate;
